import { Component, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';

import { Table } from 'primeng/table';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AllUsers } from '../../../Models/Authentication/UserModel';
import { BaseApiService } from '../../../Services/base-api.service';
import { BaseComponent } from '../../../Base/base/base.component';
import { takeUntil, finalize } from 'rxjs';
@Component({
  selector: 'app-show-all-users',
  templateUrl: './show-all-users.component.html',
  styleUrls: ['./show-all-users.component.css'],standalone:false
})
export class ShowAllUsersComponent extends BaseComponent implements OnInit {
    Users:AllUsers[]=[];
    loading:boolean=false
    id:string=''
    userForm!: FormGroup;
    constructor
    (
      private api:BaseApiService,
      private formBuilder:FormBuilder,
      private messageService:MessageService
    )
    {
       super();
    }

    getdat(){
      this.loading=true
      this.api.read("Auth/GetusersAll")
      .pipe(
        takeUntil(this.destroy$),
        finalize(() => {
          this.loading = false;
        })
      )
      .subscribe
      (
        {
           next:(response)=>{
            this.Users = response;
            this.loading=false
          }
          ,
          error:(
            error
          )=>{
            this.loading=false
            this.messageService.add({ severity: 'error', summary: 'Error', detail: error });
          }
        }
      )
    }

    deleteRecords(){
      this.loading=true;
      this.api.delete(`Auth/DeleteUser?id=${this.id}`)
      .pipe(
        takeUntil(this.destroy$),
        finalize(() => {
          this.loading = false;
        })
      )
      .subscribe(
          {
            next:(data) => {
              this.loading=false;
              this.getdat();
              this.messageService.add({ severity: 'success', summary: 'Success', detail: data.message });
            }
            ,
            error:
            (error) => {
              this.loading=false;
              this.messageService.add({ severity: 'error', summary: 'Error', detail: error});
            }
          }
      );
     }
     clear(table: Table) {
      table.clear();
    }
  selectRecord(item:string){
    this.id= item
    this.userForm.get('userId')?.setValue(this.id);
  }
  onSearchInput(event: Event, dt1: Table) {
    const input = event.target as HTMLInputElement;
    const searchValue = input.value;
    dt1.filterGlobal(searchValue, 'contains');
  }
  ngOnInit(): void {
    this.getdat();
    this.initilizaform();
  }


  initilizaform(){
    this.userForm = this.formBuilder.group
    (
      {
           userId   : [this.id],
           status   : [null, [Validators.required]],
      }
    );
  }


  onSubmit() {
    if (this.userForm.valid) {
      this.loading=true;
      const formData = this.userForm.value;
      this.api.update("Auth/UpdateStatus",formData)
      .pipe(
        takeUntil(this.destroy$),
        finalize(() => {
          this.loading = false;
        })
      )
      .subscribe(
        {
          next:(response) =>
            {
              this.loading=false
              this.getdat();
              this.messageService.add({ severity: 'success', summary: 'Success', detail: response.message });
    
            },
           error:( error) => {
           this.loading=false

          }
        }
      );
    } else {
      this.userForm.markAllAsTouched();
    }
  }
}
